import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import i from '../imports';
import c from '../components';
import withStyles from '@material-ui/core/styles/withStyles';

import BreadCrumbs from '../partials/BreadCrumbs';
import Fade from 'react-reveal/Fade';

const titleStyle = {
    fontSize: 28,
    fontWeight: "bold",
    paddingTop: "20px",
    paddingBottom: "10px"
}

const textStyle = {
    textAlign: "justify"
}
const contentTextStyle = {
    ...textStyle,
    
}

const googlemapsGpsLink = 'http://www.google.com/maps/place/'; //http://www.google.com/maps/place/lat,lng


const styles = theme => ({
    root: {
        background: '#FFFFFF',
        color: "#808080",
        fontWeight: "regular",
        height: 48,
        maxWidth: 'none',
        minWidth: "100px",
      },
      label: {
        fontSize: '14pt',
        fontFamily: `'Lato', 'Helvetica', 'Arial', 'Serif', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif`,        
        fontWeight: "regular",
        textTransform: "none",
        width: "100%",
        whiteSpace: "nowrap",
        opacity: 1,
        maxWidth: 'none',
        minWidth: "none",
        padding: '0 4px',
      },
      labelContainer: {
        padding: '0 2px',
        maxWidth: 'none',
        minWidth: "none",
      },
      flexContainer:{
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between"
      },
      scrollButtons: {
        width: '16px',
        flex: "none"
      },
      scrollButtonsAuto: {
        width: '16px',
        flex: "none"
      },
      textColorInherit: {
        opacity: 1
      },
      textColorPrimary: {
          color: '#FF5563',
      },
      indicator: {
          minWidth: "none",
          width: "100%",
          height: "4px",
      },
      selected: {
          color: '#FF5563',
      }
})

const TabItem = withStyles(styles)(i.Tab);
const TabMenu = withStyles(styles)(i.Tabs);



class DestinationPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            seesightsToShow: 2,
        }   
    }    

    handleChange = (event, value) => {
        this.setState({ value });
      };

    render() {
        
        const { value } = this.state;
        let currentDestination = Session.model.destinationPages.filter(d => d.name.toUpperCase() === this.props.city.toUpperCase())[0];

        let excursions = Session.model.excursionPages.filter(f => f.destination === this.props.city);
        excursions = i.Utils.sortByIndex(excursions);

        let destinations = Session.model.destinationPages.filter(dest => dest.name !== this.props.city);
        destinations = i.Utils.sortByIndex(destinations).slice(0, 3);;

        let relatedTours = Session.model.tourPages.filter( (f) => 
        {
            if(f.relation_destinations && f.relation_destinations.map(m => m.destinationpages).indexOf(currentDestination.name) > -1)
                return true;
            return false;
        });
        relatedTours = i.Utils.sortByIndex(relatedTours);

        
        let galleryPictures = currentDestination.destinationImages ? currentDestination.destinationImages.map(i => `${i.pic}`) : [];

        let subMenu = ["about_city", "general_info", "seesights", "where_to_eat", "what_to_bring", "recommendations" ];

        return (
                <BasePage data={Session.model.destinationPages}>
                   <BreadCrumbs fullpath={window.location.pathname} name={currentDestination.translations[0].title} md={10} />
                    <i.PureGridProvider>
                        <i.Container>
                            <i.Row justify='center'  style={{paddingBottom: 20, paddingTop:20}}>
                                <i.Col md={6}  >
                                    <c.Gallery images={galleryPictures} imgMaxHeight='446px' />
                                </i.Col>
                                <i.Col md={4} align='center' >
                                    <div style={{paddingBottom: "16px", height: "280px"}}>
                                        <c.AddressToMapComponent  latitude={currentDestination.location.latitude} longitude={currentDestination.location.longitude} />
                                    </div>
                                    <div>
                                        <button className='button-show-on-map' style={{cursor: "pointer"}} onClick={() => {window.open(`${googlemapsGpsLink}${currentDestination.location.latitude},${currentDestination.location.longitude}`,'_blank')}}>{Session.model.common.words.show_on_map}</button>
                                    </div>
                                </i.Col>
                            </i.Row>
                            <i.Row justify='center' style={{paddingBottom: 20}}> 
                                <i.Col md={10} >
                                    <TabMenu
                                        value={value}
                                        onChange={this.handleChange}
                                        scrollable
                                        scrollButtons="auto"                                      
                                    >
                                    {subMenu.map(m => 
                                        <TabItem label={Session.model.common.destinaion_tabs[`${m}`]}  />
                                    )} 
                                    </TabMenu>
                                                                          
                                    {value === 0 && <AboutCityTab data={currentDestination} />}
                                    {value === 1 && <GeneralInfoTab data={currentDestination} />}
                                    {value === 2 && <SeesightsTab data={currentDestination}  />}
                                    {value === 3 && <RestaurantTab  data={currentDestination} />}
                                    {value === 4 && <WhatToBringTab data={currentDestination} />}
                                    {value === 5 && <RecommendationsTab data={currentDestination} />}
                                </i.Col>
                            </i.Row>
                            {excursions.length > 0 ?
                                <i.Row style={{paddingBottom: 20}}>
                                    <i.Col>                                        
                                        <div>
                                            <h2>{`${Session.model.destinations.excursions_in} ${currentDestination.translations[0].title}`}</h2>
                                            <c.CardsList items={excursions} urlBuilder={i.Utils.createExcursionUrl} />
                                            <h2><i.NavLink style={{color: "#FF5563", textDecoration: "none"}} to={i.Utils.locUrl(`excursions/`)}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                        </div>
                                    </i.Col>
                                </i.Row>   
                                : null
                            }
                            {relatedTours.length > 0 ?
                                <i.Row style={{paddingBottom: 20}}>
                                    <i.Col>
                                        <div>
                                            <h2>{`${Session.model.destinations.tours_in} ${currentDestination.translations[0].title}`}</h2>
                                            <c.CardsList items={relatedTours} urlBuilder={i.Utils.createTourUrl} />
                                            <h2><i.NavLink style={{color: "#FF5563", textDecoration: "none"}} to={i.Utils.locUrl(`tours/`)}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                        </div>
                                    </i.Col>
                                </i.Row>
                                : null
                            }
                            {destinations.length > 0 ?
                                <i.Row style={{paddingBottom: 20}}>
                                    <i.Col>
                                        <div>
                                            <h2>{Session.model.common.words.other_destinations}</h2>
                                            <c.CardsList items={destinations} urlBuilder={i.Utils.createDestinationUrl} />
                                            <h2><i.NavLink style={{color: "#FF5563", textDecoration: "none"}} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                        </div>
                                    </i.Col>
                                </i.Row>
                                : null
                            }                       
                        </i.Container>
                    </i.PureGridProvider>                    
                </BasePage>
        );
    }
}


class AboutCityTab extends Component {
    
    render() {
        return (
            <i.PureGridProvider>
                <i.Container>
                    <i.Row style={{marginTop: '20px'}} justify='center' align='center' >
                        <i.Col md={12} className="content-text" style={contentTextStyle}>
                        {i.markdown(this.props.data.translations[0].text)}
                        </i.Col>
                    </i.Row>
                </i.Container>
            </i.PureGridProvider>
        )};
}

class GeneralInfoTab extends Component {
    
    render() {
        return (
            <i.PureGridProvider>
                <i.Container>
                    <i.Row justify='center' align='center'  style={{marginTop: '20px'}}>
                        <i.Col md={12} align='left' className="content-text" style={contentTextStyle}>
                        {i.markdown(this.props.data.translations[0].general_info)}
                        </i.Col>
                    </i.Row>
                </i.Container>
            </i.PureGridProvider>
        )};
}

class SeesightsTab extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            seesightsToShow: 3,
        }   
    }    
    
    showMoreSeesights = () => {
        this.setState({
            seesightsToShow: this.state.seesightsToShow + 3
        })
    }

    render() {

        let seesightsCollection = this.props.data.seesights;

        if(seesightsCollection === undefined || seesightsCollection.length <= 0)
            return (
                <div style={{marginTop: '20px', paddingTop: '20px'}}></div>
            )

        let seesightsToShow = seesightsCollection.slice(0, this.state.seesightsToShow);

        return (
            
            <i.PureGridProvider>
                <i.Container>
                    {seesightsCollection.map(m => 
                        <Fade>
                            <i.Row style={{marginTop: '20px', paddingBottom: "30px"}}>
                                <i.Col md={12} align='left'>
                                    {i.Utils.getTranslationForCurrentLang(m.translations) !== undefined
                                        ? <c.ImageWithDescription title={i.Utils.getTranslationForCurrentLang(m.translations).name} text={i.Utils.getTranslationForCurrentLang(m.translations).text} pic={m.pic}/>
                                        : null
                                    }
                                </i.Col>
                            </i.Row>
                        </Fade>
                    )}
                    {/* {seesightsCollection.length > this.state.seesightsToShow ? 
                    <i.Row>
                        <i.Col>
                            <div style={{color: "#FF5563", textDecoration: "none", cursor: "pointer"}} onClick={() => this.showMoreSeesights()}><h2>{Session.model.common.words.find_more}</h2></div>
                        </i.Col>
                    </i.Row>
                    : null    */}
                </i.Container>
            </i.PureGridProvider>
            
        )};
}

class RestaurantTab extends Component {
    
    render() {

        let cityRestaurants = this.props.data.restaurants || [];

        let restaurantsCards = cityRestaurants.map ( m => (
            
            {
                name: i.Utils.getTranslationForCurrentLang(m.translations) !== undefined ? i.Utils.getTranslationForCurrentLang(m.translations).name : "not translated",
                text: i.Utils.getTranslationForCurrentLang(m.translations) !== undefined ? i.Utils.getTranslationForCurrentLang(m.translations).text : "not translated",
                pic: m.pic,
                address: m.address
            })
        )

        return (
            <i.PureGridProvider>
                <i.Container>
                    <i.Row style={{marginTop: '20px', paddingBottom: "10px"}} justify='center' align='center' >
                        <i.Col md={12} align='left' className="content-text" style={contentTextStyle}>
                            <div>{i.markdown(this.props.data.translations[0].cuisine_text)}</div>
                        </i.Col>
                    </i.Row>
                    <i.Row style={{paddingBottom: "30px"}}>
                        <i.Col md={12} align='left' >
                            <c.CardsCarousel data={restaurantsCards} buttonText={Session.model.common.words.show_on_map} backgroundColor='#F5F5F5'/>
                        </i.Col>
                    </i.Row>
                </i.Container>
            </i.PureGridProvider>
        )};
}

class WhatToBringTab extends Component {
    
    render() {
        let souvenirs = this.props.data.what_to_bring || [];

        let souvenirsCards = souvenirs.map ( m => (           
            {
                name: i.Utils.getTranslationForCurrentLang(m.translations) !== undefined ? i.Utils.getTranslationForCurrentLang(m.translations).name : "not translated",
                text: i.Utils.getTranslationForCurrentLang(m.translations) !== undefined ? i.Utils.getTranslationForCurrentLang(m.translations).text : "not translated",
                pic: m.pic,
                address: m.address
            })
        )

        return (
            <i.PureGridProvider>
                <i.Container>
                    <i.Row style={{marginTop: '20px', paddingBottom: "10px"}} justify='center' align='center' >
                        <i.Col md={12} align='left' className="content-text" style={contentTextStyle}>
                            <div>{i.markdown(this.props.data.translations[0].what_to_bring_text)}</div>
                        </i.Col>
                    </i.Row>
                    <i.Row>
                        <i.Col md={12} align='left' >
                            {/* <c.CardsCarousel data={souvenirsCards} buttonText={Session.model.common.words.show_on_map} backgroundColor='#F5F5F5'/> */}
                            <i.OnAtMostTablet>
                                <c.Slider items={souvenirsCards} itemComponent={c.SouvenirItem} slidesToShow={1} className="slick-souvenir" style={{paddigTop:50, paddingBottom:50}} />
                            </i.OnAtMostTablet>
                            <i.OnDesktop>
                                <c.Slider items={souvenirsCards}  itemComponent={c.SouvenirItem} slidesToShow={Math.min(souvenirsCards.length, 3)} className={souvenirsCards.length == 2 ? "" : "slick-souvenir"} style={{paddigTop:50, paddingBottom:50}} />
                            </i.OnDesktop>
                        </i.Col>
                    </i.Row>
                </i.Container>
            </i.PureGridProvider>
        )};

        
}

class RecommendationsTab extends Component {
    
    render() {
        return (
            <i.PureGridProvider>
                <i.Container>
                    <i.Row style={{marginTop: '20px'}} justify='center' align='center' >
                        <i.Col md={12} align='left' className="content-text" style={contentTextStyle}>
                            {i.markdown(this.props.data.translations[0].recommendations_text)}
                        </i.Col>
                    </i.Row>
                </i.Container>
            </i.PureGridProvider>
        )};
}


export default DestinationPage;